import { lazy, Suspense, type ReactNode } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { Spinner } from "@/components/ui/Spinner";
import { AdminAuthProvider } from "@/context/AdminAuthContext";

const AdminLogin = lazy(() =>
  import("@/pages/admin/AdminLogin").then((module) => ({ default: module.AdminLogin })),
);
const AdminDashboard = lazy(() =>
  import("@/pages/admin/AdminDashboard").then((module) => ({ default: module.AdminDashboard })),
);
const InvitePage = lazy(() =>
  import("@/pages/invite/InvitePage").then((module) => ({ default: module.InvitePage })),
);
const InviteUnavailable = lazy(() =>
  import("@/components/invitation/InviteUnavailable").then((module) => ({
    default: module.InviteUnavailable,
  })),
);

function Admin({ children }: { children: ReactNode }) {
  return (
    <Suspense
      fallback={
        <main className="grid min-h-dvh place-items-center bg-[#f8f1e8]">
          <Spinner />
        </main>
      }
    >
      {children}
    </Suspense>
  );
}

function Guest({ children }: { children: ReactNode }) {
  return (
    <Suspense
      fallback={
        <main className="grid min-h-dvh place-items-center bg-[#f7f0e5] text-[#5b1f2a]/font-serif">
          Preparing your invitation…
        </main>
      }
    >
      {children}
    </Suspense>
  );
}

export default function App() {
  return (
    <AdminAuthProvider>
      <Routes>
        <Route path="/" element={<Navigate to="/admin/login" replace />} />
        <Route
          path="/invite/:token"
          element={
            <Guest>
              <InvitePage />
            </Guest>
          }
        />
        <Route
          path="/admin/login"
          element={
            <Admin>
              <AdminLogin />
            </Admin>
          }
        />
        <Route
          path="/admin/dashboard"
          element={
            <Admin>
              <AdminDashboard />
            </Admin>
          }
        />
        <Route path="/admin/dashboard/*" element={<Navigate to="/admin/dashboard" replace />} />
        <Route
          path="*"
          element={
            <Guest>
              <InviteUnavailable />
            </Guest>
          }
        />
      </Routes>
    </AdminAuthProvider>
  );
}
